import React from 'react'

import { AssetWithdrawalProvider } from '@/components/base/AssetWithdrawal/context'
import TokenPickerRevampProvider from '@/components/base/TokenPickerRevamp/context'
import { WrapperTokensFlowProvider } from '@/components/base/WrappedTokensFlow/context'
import TopCoinsPage from '@/components/top-coins'
import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const TopCoins = () => {
  return (
    <MainLayout>
      <WrapperTokensFlowProvider>
        <AssetWithdrawalProvider>
          <TokenPickerRevampProvider>
            <TopCoinsPage />
          </TokenPickerRevampProvider>
        </AssetWithdrawalProvider>
      </WrapperTokensFlowProvider>
    </MainLayout>
  )
}

export default TopCoins

export const getServerSideProps = gssp()
